import { z } from 'zod';
import { AiSuggestionModel, MasterListItem } from './master-list-items';
import { TripItemWithLabels } from './trip-items';

/**
 * AI reconcile/audit between a trip's list and its source master list. The API
 * semantically diffs the two and returns what's only on each side plus the
 * matched pairs (with flags for which fields differ, to drive a per-field merge).
 */

/** POST /api/trips/:tripId/reconcile/:listId body. */
export const ReconcileTripListInput = z.object({
  model: AiSuggestionModel.default('gpt_fast'),
});
export type ReconcileTripListInput = z.infer<typeof ReconcileTripListInput>;

/** A pair the AI judged to be the same item, with field-level diff flags. */
export const ReconcileMatch = z.object({
  masterItem: MasterListItem,
  tripItem: TripItemWithLabels,
  nameDiffers: z.boolean(),
  descriptionDiffers: z.boolean(),
});
export type ReconcileMatch = z.infer<typeof ReconcileMatch>;

export const ReconcileResult = z.object({
  /** In the library list but missing from the trip — candidates to pull in. */
  onlyInMaster: z.array(MasterListItem),
  /** In the trip but missing from the library list — candidates to push back. */
  onlyInTrip: z.array(TripItemWithLabels),
  /** Same item on both sides (possibly worded/detailed differently). */
  matched: z.array(ReconcileMatch),
});
export type ReconcileResult = z.infer<typeof ReconcileResult>;
